import { Tabs } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { FormListPageStore } from 'stores/local';

import NotificationHistoryTab from '../NotificationHistoryTab';
import SendNotificationTab from '../SendNotificationTab';
import s from './NotificationDrawerContent.module.scss';

type NotificationDrawerContentProps = {
  formId: number;
  store: FormListPageStore;
  activeTab: string;
  onTabChange: (tab: string) => void;
};

const NotificationDrawerContent: React.FC<NotificationDrawerContentProps> = ({
  formId,
  store,
  activeTab,
  onTabChange,
}) => {
  const { t } = useTranslation();

  React.useEffect(() => {
    if (activeTab === 'history') {
      store.fetchNotifications(formId);
    }
  }, [activeTab, formId, store]);

  return (
    <div className={s.content} onClick={(e) => e.stopPropagation()}>
      <Tabs
        activeKey={activeTab}
        onChange={onTabChange}
        items={[
          {
            key: 'send',
            label: t('formList.notifications.sendTab'),
            children: (
              <SendNotificationTab
                formId={formId}
                store={store}
                onSuccess={() => {
                  onTabChange('history');
                  store.fetchNotifications(formId);
                }}
              />
            ),
          },
          {
            key: 'history',
            label: t('formList.notifications.historyTab'),
            children: (
              <NotificationHistoryTab formId={formId} store={store} />
            ),
          },
        ]}
      />
    </div>
  );
};

export default observer(NotificationDrawerContent);
